/* Decode reveal. Elements with [data-decode] scramble through a glyph set and resolve left to right the
   first time they scroll into view (Anduril-style). [data-decode="digits"] keeps the glyph set numeric so
   widths hold steady. Elements with [data-fade] settle from mute to full colour. Once per element,
   staggered per group, off under prefers-reduced-motion. Plain-text elements only. */
(function () {
  'use strict';
  if (window.__rrDecode) return; window.__rrDecode = true;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const GLYPHS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789#%&/-_<>[]';
  const DIGITS = '0123456789';
  const items = [...document.querySelectorAll('[data-decode], [data-fade]')];
  if (!items.length) return;
  if (reduced) { items.forEach(el => el.classList.add('is-decoded')); return; }

  function decode(el) {
    if (el.dataset.decoded || el.children.length) { el.classList.add('is-decoded'); return; }
    el.dataset.decoded = '1';
    const final = el.textContent, len = final.length;
    if (!len || len > 80) { el.classList.add('is-decoded'); return; }
    const set = el.dataset.decode === 'digits' ? DIGITS : GLYPHS;
    const dur = Math.min(1100, 380 + len * 22), delay = +(el.dataset.decodeDelay || 0);
    const t0 = performance.now() + delay;
    el.style.minWidth = el.getBoundingClientRect().width + 'px';
    const tick = now => {
      const p = Math.max(0, Math.min(1, (now - t0) / dur));
      const cut = Math.floor(p * len);
      let out = '';
      for (let i = 0; i < len; i++) {
        const c = final[i];
        if (i < cut || c === ' ' || c === '\n' || c === '·' || c === '.' || c === '/' || c === ':') out += c;
        else out += set[(Math.random() * set.length) | 0];
      }
      el.textContent = out;
      if (p < 1) requestAnimationFrame(tick); else { el.textContent = final; el.classList.add('is-decoded'); el.style.minWidth = ''; }
    };
    requestAnimationFrame(tick);
  }

  const io = new IntersectionObserver(entries => {
    let k = 0;
    entries.forEach(e => {
      if (!e.isIntersecting) return;
      io.unobserve(e.target);
      const el = e.target;
      if (el.hasAttribute('data-decode')) { el.dataset.decodeDelay = el.dataset.decodeDelay || String(k * 60); decode(el); k++; }
      if (el.hasAttribute('data-fade')) el.classList.add('is-decoded');
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.2 });
  items.forEach(el => io.observe(el));
})();
